import {palette, updatePrimaryPalette, updateSurfacePalette} from "@primeng/themes";
import {PrimeNGConfigType} from "primeng/config";
import { preset } from "./preset";
import { MyPreset } from "./a19Preset";

export const zenTheme: PrimeNGConfigType = {
  ripple: true,
  theme: {
    preset: MyPreset ||  preset,
    options: {
      darkModeSelector: 'none'
    }
  }
}

export function onThemeChange() {
  setTimeout(() => {
    changePrimaryColor();
    changeSurfaces();
  }, 2 * 1000)
  // changeSurfaces();
}

function changePrimaryColor() {
  const style = window.getComputedStyle(document.body).getPropertyValue('--primary-color')
  console.log(style);
  if (!style) {
    return;
  }
  const val = palette(style);
  updatePrimaryPalette(val);
}


function changeSurfaces() {
  const color = window.getComputedStyle(document.body).getPropertyValue('--surface-600');
  if(!color){
    return;
  }
  const val = palette(color);
  updateSurfacePalette(val);
}

